import { Guid } from "guid-typescript";
import ComplementaryData from "./ComplementaryData";
import HeightSupplement from "./HeightSupplement";
import OperationGroup from "./OperationGroup";

/**
 * SubBop TypeScript model mirroring Touch.Api.Models.SubBop
 * Represents a sub-BOP (used for Multi-Echafaudage) with its own local totals
 * and collections of operations, coefficients, height supplements, visas and febs.
 */
export default class SubBop {
  public id: string;
  // Parent BOP id (container)
  public febId: string;

  // identify/label this sub BOP
  public name: string;
  public sequenceOrder?: number;

  // Local totals for this sub BOP (A/B/C/D and min facturable logic applied per sub)
  public totalPoints?: number;
  public totalOperationPrincipalPoints?: number;
  public totalOperationDiversePoints?: number;
  public totalOperationSuppHeurePoints?: number;
  public totalSuppHauteurPoints?: number;
  public totalOperationSuppEpiPoints?: number;

  // Collections owned by the SubBop (not the parent)
  public operationGroups: Array<OperationGroup>;
  public coefficientSelectedValues: Array<any>; // keep as any until a dedicated model is wired
  public heightSupplements: Array<HeightSupplement>;

// each set of operations is contained in an operation group
  public operationDiverseGroups: Array<OperationGroup>;
  public operationPrincipalGroups: Array<OperationGroup>;
  public operationSuppGroups: Array<OperationGroup>;
  public complementaryData: null | ComplementaryData;
  public selectedGlobalCoefficients: any;
 public multipleSelectedGlobalCoefficients: Record<string, any[]>;
  public isValid: boolean = true;

  constructor() {
    this.id = Guid.create().toString();
    this.febId = Guid.createEmpty().toString();

    this.name = "";
    this.sequenceOrder = undefined;

    this.totalPoints = undefined;
    this.totalOperationPrincipalPoints = undefined;
    this.totalOperationDiversePoints = undefined;
    this.totalOperationSuppHeurePoints = undefined;
    this.totalSuppHauteurPoints = undefined;
    this.totalOperationSuppEpiPoints = undefined;

    this.operationDiverseGroups = [new OperationGroup()];
    this.operationPrincipalGroups = [];
    this.operationSuppGroups = [new OperationGroup()];
        this.complementaryData = null;
    this.operationGroups = [];
    this.coefficientSelectedValues = [];
        this.multipleSelectedGlobalCoefficients = {};
    this.heightSupplements = [];
    this.isValid = false;
  }
}
